export default __webpack_public_path__ + "static/media/Fabra.ffb781cd.jpg";